export const TargetZoneStatus = {
  aboveTarget: 'Above target',
  onTarget: 'On target',
  belowTarget: 'Below target',
  extendedBelowTarget: 'Extended below target',
};
